import * as React from "react";
import type { ReactUiPaintTimingProps } from "./ReactUiPaintTiming.Props";
import { AppContext } from "@1js/acui-context";
import { UiPaintTiming } from "../../UiPaintTiming";

/**
 * Create a minimal DOM element which enables tracking paint time of the react component using Element Timing API
 * @param props: ReactUiPaintTimingProps
 *
 * props.elementTimingId: the id of the element timing observer - used to correlate with the track call in the interactivity tracker
 * props.hidden: if true, the element will not be rendered to the DOM.
 *
 * Use hidden to re-measure elements that are already in the DOM but having their visibility toggled.
 */
export class ReactUiPaintTiming extends React.PureComponent<
  ReactUiPaintTimingProps,
  {}
> {
  // This allows us to access AppContext directly from this.context
  static contextType: any = AppContext;
  declare context: React.ContextType<typeof AppContext>;
  public fromWrapper: boolean = false;

  constructor(props: ReactUiPaintTimingProps, isFromWrapper?: boolean) {
    super(props);
    this.fromWrapper = isFromWrapper === true;
  }

  public render() {
    const {
      elementTimingId,
      hidden = false,
      interactivityTrackerContext,
    } = this.props;

    let featureChecker;
    if (this.context?.isExperimentalFeatureEnabled) {
      featureChecker = this.context?.isExperimentalFeatureEnabled;
    } else if (!this.fromWrapper) {
      featureChecker = this.props.isChangeGateEnabled;
    }

    return UiPaintTiming.getReactElement(
      elementTimingId,
      !!featureChecker?.(
        "SharedOnline.ChangeGate.OfficeVSO_9513221_removeTransparantStyle"
      ) /* withoutTransparentStyle */,
      interactivityTrackerContext,
      hidden
    );
  }
}
